import lang_global from './_lang_global'
import auth from '@/modules/user/auth/lang/de/lang'
import user from '@/modules/user/user/lang/de/lang'

export default {
    "g": lang_global,
    "auth": auth,
    "user": user,
}
